export const MILLET_START_TOUR_EVENT = 'millet-start-tour';

export default function startTour() {
  localStorage.removeItem('tourCompleted');
  localStorage.removeItem('currentTourStep');
  localStorage.setItem('shouldStartTour', 'true');
  window.dispatchEvent(new Event(MILLET_START_TOUR_EVENT));
}
